function _(t,n,r){var i=String.prototype.indexOf;n.exports=function(t){return i.call(this,t,arguments[1])>-1}}
//# sourceMappingURL=shim.min.js.map